import s from "./SectionPricesAddFeatures.module.scss";
import { Button } from "../../UI/Buttons/Button";
import iconPlus from "public/img/icons/svg/plus.svg";
import cn from "classnames";
import cs from "@/styles/modules/card.module.scss";
import Image from "next/image";
import { extraFeaturesImages } from "@/helpers/extraFeatures";

type ExtraFeatureCardProps = {
  id: number;
  name?: string;
  customerName?: string;
  customerDescription?: string;
  flatSurcharge: number;
  percentageSurcharge: number;
  onClick: () => void;
};

export const ExtraFeatureCard = ({
  id,
  name,
  customerName,
  flatSurcharge,
  percentageSurcharge,
  customerDescription,
  onClick,
}: ExtraFeatureCardProps) => {
  const price = percentageSurcharge
    ? `+${percentageSurcharge}% to the page price`
    : flatSurcharge
    ? `$${flatSurcharge}`
    : "";

  return (
    <div className={cn(cs.cardGlass, s.card)} onClick={onClick}>
      <div className={s.inner}>
        <div>
          {extraFeaturesImages[id] && (
            <div className={s.imgWrap}>
              <Image
                src={`/img/icons/extra-features/${extraFeaturesImages[id]}.png`}
                alt=""
                width={150}
                height={137}
                quality={100}
              />
            </div>
          )}

          <h3 className={cn(cs.h3sm, s.title)}>{customerName || name}</h3>
          <p className={s.text}>{customerDescription}</p>
        </div>
        <div>
          <p className={s.price}>{price}</p>
          <Button
            type="primary"
            outline
            icon={iconPlus}
            iconPosition="suffix"
            size="fullwidth"
            className={s.button}
          >
            Add premium feature
          </Button>
        </div>
      </div>
    </div>
  );
};
